export default __webpack_public_path__ + "static/wsl-grafana-login-success-edf1ca8e48c905ec5a6b9391a2edf831.webp";